<template>
  <span>
    <b-badge v-if="!editingMode" v-on:dblclick="startEditing" :class="badgeClass" :variant="badgeVariant">
      <slot></slot>
    </b-badge>

    <input
      v-else
      :id="badgeUniqueId"
      :placeholder="badgeValue"
      autocomplete="off"
      ref="editingInput"
      class="classic-input border rounded"
      v-on:blur="saveValue"
      v-model="editingValue"
      v-on:keyup="onEnterPress"
      v-on:keypress="callback"
    />
  </span>
</template>

<script>
export default {
  props: {
    badgeId: {
      type: Number,
      required: true,
    },
    badgeValue: {
      type: [String, Number],
      required: true,
    },
    badgeClass: {
      type: Array,
      default: () => [],
    },
    badgeVariant: {
      type: String,
    },
    limit: {
      type: Number,
      default: -1,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    callback: {
      type: Function,
    },
  },

  data() {
    return {
      inputValue: '',
      isEditing: false,
    }
  },

  computed: {
    badgeUniqueId: {
      get() {
        return 'badge-n-' + this.badgeId
      },
    },

    editingMode: {
      get() {
        return this.isEditing
      },
      set(newValue) {
        this.isEditing = newValue
      },
    },

    editingValue: {
      get() {
        return this.inputValue
      },
      set(newVal) {
        this.inputValue = newVal
      },
    },
  },

  methods: {
    startEditing() {
      if (!this.editable) {
        return
      }
      this.editingMode = true
      this.editingValue = null
      this.$nextTick(() => {
        this.$refs.editingInput.focus()
      })
    },

    onEnterPress(event) {
      // 13 = Tab; 27 = Esc;
      return [13, 27].includes(event.keyCode) ? this.saveValue() : null
    },

    saveValue() {
      if (!this.editingValue) {
        this.editingValue = this.badgeValue
      }
      this.editingMode = false
      this.$emit('update-value', {
        index: this.badgeId,
        value: this.limit !== -1 && this.editingValue >= this.limit ? this.limit : this.editingValue,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.classic-input {
  margin-right: 0.8px;
  width: auto !important;
  display: inline !important;
  max-width: 80px !important;
  min-width: 30px !important;
  background-color: white !important;
}

.classic-input::placeholder {
  font-size: 90% !important;
}
</style>
